import isMOSLaunchPagesEnabled from './utils/isMOSLaunchPagesEnabled';
import { isFeatureEnabled } from 'owa-feature-flags';

const supportedOfficeRailApps = [
    'db5e5970-212f-477f-a3fc-2227dc7782bf', // Communities,
    '4c4ec2e8-4a2c-4bce-8d8f-00fc664a4e5b', // Bookings,
    '9b049ed6-fc8b-40c7-815b-bf84e344d270', // Org Explorer,
    'f3a6e67f-850d-4dd9-960a-04c6638ded36', // App Store
    'Y29tLm1pY3Jvc29mdC50ZWFtc3BhY2UudGFiLnBsYW5uZXIjIzEuMi4zIyNQdWJsaXNoZWQ=', // Planner
    'MmUzYTYyOGQtNmY1NC00MTAwLTllN2EtZjAwYmMzNjIxYTg1IyMxLjAuOCMjUHVibGlzaGVk', // Learning
    'ZGI1ZTU5NzAtMjEyZi00NzdmLWEzZmMtMjIyN2RjNzc4MmJmIyMyLjIuMyMjUHVibGlzaGVk', // Yammer
    ...(isFeatureEnabled('mos-testApp') ? ['com.example.metaostestapp.test'] : []), // Test App
];

export default function isSupportedOfficeRailApp(appName: string) {
    return isMOSLaunchPagesEnabled() && supportedOfficeRailApps.indexOf(appName) > -1;
}
